export enum PerformanceSetting {
  ProjectRevenueShare = 1,
  PointXpConversion = 2,
  BidLoiMinutesAddendRecEngine = 3,
  PartnerLoiMinutesAddendRecEngine = 4,
  BidIrDivisorRecEngine = 5,
  PartnerIrDivisorRecEngine = 6,
  BidIrCeilingRecEngine = 7,
  BidIrFloorRecEngine = 8,
  ActualPerformantMultiplierRecEngine = 9,
  PartnerPerformantMultiplierRecEngine = 10,
  FiveStarIrPercentRecEngine = 11,
  OneStarIrPercentRecEngine = 12,
  CintWeightRecEngine = 13,
  MinEntriesForMetrics = 14,
  MinCompletesForMetrics = 15,
  MinNonCompleteTermsForMetrics = 16,
  RegistrationBonus = 18,
  DynamicProfilerInviteThreshold = 19,
  SpectrumWeightRecEngine = 20,
  MaxXpFromTermsIn24HoursWithoutComplete = 21,
  MaxXpFromTermsWithoutComplete = 22,
  ProjectPointCeiling = 23,
  SpectrumFusionProjectCountRequested = 24,
  CountMissingQualsAllowedForPartialMatch = 25,
  HomepageProjectInvitesLimit = 26,
  MinLoiSecondsForRating = 27,
  CintQuotaThreshold = 28,
  IrFloorEntryEligibilityFilter = 29,
  CintAllocatedClosedProjectsBatchSize = 30,
  CintNonAllocatedProjectsBatchSize = 31,
  SpectrumFusionMinCpiCents = 32,
  SpectrumFusionThrottleMinutes = 33,
  RpiWeightRecEngine = 34,
  IrWeightRecEngine = 35,
  LoiWeightRecEngine = 36,
  MinXpForNonCompleteTermination = 37,
  MaxXpForNonCompleteTermination = 38,
  CintAllocatedOpenProjectsBatchSize = 39,
  DynataNotificationsWorkersCount = 40,
  DynataWeightRecEngine = 41,
  StreakBonusDay2 = 42,
  StreakBonusDay4 = 43,
  StreakBonusDay7 = 44,
  QuestMinLoiSecondsNeeded = 53,
  NewQuestProjectExitProbability = 54,
  MinQuestChestPointsRewardFloor = 55,
  MinQuestChestPointsRewardCeiling = 56,
  MaxQuestChestPointsRewardFloor = 57,
  MaxQuestChestPointsRewardCeiling = 58,
  ChanceOfQuestChest1FreezeReward = 59,
  ChanceOfQuestChest2FreezeReward = 60,
  ChanceOfQuestChest3FreezeReward = 61,
  QuestChestXpRewardVarianceRange = 62,
  QuestChestPointsPercentFloor = 63,
  QuestChestPointsPercentCeiling = 64,
  MinQuestChestXpRewardFloor = 65,
  MinQuestChestXpRewardCeiling = 66,
  MatchUserToGamesThrottleMinutes = 67,
  PendingDelayMinutesFor200To500GamePoints = 68,
  PendingDelayMinutesFor500AndAboveGamePoints = 69,
  PendingDelayMinutesForUnder200GamePoints = 70,
  HomepageGameInvitesLimit = 71,
  PartnerRpsBenchmarkGameRecEngine = 72,
  PartnerRpipBenchmarkGameRecEngine = 73,
  ActualRpsBenchmarkGameRecEngine = 74,
  ActualRpipBenchmarkGameRecEngine = 75,
  GameScoreSoftCapMultiplierGameRecEngine = 76,
  GameScoreBenchmarkPercentileGameRecEngine = 77,
  FiveStarScoreGameRecEngine = 78,
  ThreePointFiveStarScoreGameRecEngine = 79,
  MinGameViewsForRevenueMetrics = 80,
  MinGameStartsForRevenueMetrics = 81,
  MinGameInProgressForRevenueMetrics = 82,
  MinGameCompletesForDurationMetrics = 83,
  MinGameGoalCompletesForGameGoalDurationMetrics = 84,
  XpForGameGoalWithoutReward = 85,
  DailyStreakPointsTarget = 86,
  UseMeasuredGameScore = 87,
  EstimateWeightGameSessionsGameRecEngine = 88,
  MinGameSessionsForGameSessionMaturationSchedule = 89,
  PartnerRpsAdjustmentIosGameRecEngine = 90,
  PartnerRpsAdjustmentAndroidGameRecEngine = 91,
  BlendedRpsBenchmarkIosGameRecEngine = 92,
  BlendedRpsBenchmarkAndroidGameRecEngine = 93,
  AyetOfferwallThrottleMinutes = 952,
  AyetOfferwallNumOffers = 953,
  AyetOfferwallMinimumPayout = 954,
  BrowserNotificationsOptInPoints = 955,
  StreakFreezeFirstChancePercent = 956,
  StreakFreezeStandardChancePercent = 957,
  StreakFreezeUnlockLevel = 958,
  StreakFreezeSlot2UnlockLevel = 50,
  StreakFreezeSlot3UnlockLevel = 51,
  DynataQualifyApiCallDelaySeconds = 52,
  TheoremReachWeightRecEngine = 47,
  CpxResearchWeightRecEngine = 48,
  TapResearchWeightRecEngine = 49,
  TapResearchThrottleMinutes = 1000,
  TapResearchHotTileMultiplierRecEngine = 1001,
  AyetWeightRecEngine = 1002,
  AyetSurveysSyncIntervalMinutes = 1003,
  AyetSurveysDefaultLoiMinutes = 1004,
  AyetSurveysDefaultIrPercent = 1005,
  QuestCandidateRerollLimit = 1006,
  QuestCandidateRerollCooldownMinutes = 1007,
  QuestCandidateSetLifetimeHours = 1008,
  QuestCandidateDailyGenerationLimit = 1009,
  NotificationGlobalDailyCap = 1012,
  NotificationTopicDailyCap = 1013,
  NotificationExpiryReminderWindowHours = 1014,
  NotificationStandardRetentionDays = 1015,
  NotikOfferwallThrottleMinutes = 1016,
  NotikOfferwallNumOffers = 1017,
  AffiliateCommissionRate = 999,
  AffiliateRegistrationBonus = 998,
}
